import {RouteService} from '../services/route.service'

export function routeInitializer(
  routeService: RouteService,
  window: Window
): void {
  const url = window.location.href
  const isHorse = url.includes('hast')

  if (isHorse) {
    routeService.onHorseRoute.set(true)
    window.document.body.classList.add('theme-horse')
  }
}